import { platform } from '../utils/enum/search-branches-enum';

export const content = {
  platform: {
    all: 'ทั้งหมด',
    cj: 'ซีเจ มอร์',
    td: 'ถูกดี มีมาตราฐาน',
    cjx: 'ซีเจ เอ็กซ์',
  },
  productType: {
    all: 'ประเภทสินค้าและบริการทั้งหมด',
  },
  fillterMode: {
    platform: platform.CJ,
    isFillter: true,
  },
};

export const commonURL = 'https://website-branches-search.obs.ap-southeast-2.myhuaweicloud.com';
